import _ from 'lodash';
import { HelperService } from '../helper.service';
import { AgentAdvancedAgent } from './agent-advanced-agent';
import { AgentAdvancedLicensePlan } from './agent-advanced-license-plan';
import { AgentAdvancedState } from './agent-advanced-state';
import { AgentSalesAgent } from './agent-sales-agent';

export class AgentAdvanced {
	public licensePlans: AgentAdvancedLicensePlan[];
	public parent: AgentAdvancedAgent;
	public brother: AgentAdvancedAgent;
	public state: AgentAdvancedState;
	public agentId: string;
	public brotherId: string;
	public parentId: string;
	public stateId: string;
	public name: string;
	public contactName: string;
	public email: string;
	public phone: string;
	public city: string;
	public commissionRate: number;
	public commissionRate2: number;
	public commissionRate3: number;
	public hasFailedPayment: number | boolean;
	public isActive: number | boolean;
	public showUtilityCheck: number | boolean;
	public addDate: string;
	public isNewBroker: boolean;

	public licensePlan: string;
	public displayName: string;
	public salesAgents: AgentSalesAgent[];

	constructor(agentAdvanced: AgentAdvanced) {
		Object.assign(this, agentAdvanced);

		this.parent = this.parent ? new AgentAdvancedAgent(this.parent) : this.parent;
		this.brother = this.brother ? new AgentAdvancedAgent(this.brother) : this.brother;
		this.licensePlan = this.licensePlans ? this.licensePlans.find(l => ['Business Lite', 'Platinum', 'Gold', 'Silver'].includes(l.name))?.name : '';
		this.salesAgents = this.salesAgents
			? _.orderBy(
					this.salesAgents.map(sa => new AgentSalesAgent(sa)),
					sa => sa.salesAgent.name,
				)
			: this.salesAgents;

		this.displayName = HelperService.showAsteriskForBrokerFirstImpression(this.isNewBroker) ? this.name + '*' : this.name;
	}
}
